// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container that anchors the agent avatars just below their target node. The
   UniversalNode wrapper is display:contents, so this absolute box anchors to
   the .react-flow__node element and rides along with pan/zoom/drag. The avatar
   chips themselves are the shared AgentAvatarBadge. */
.fNLP7EvNWNeXaHy9b620 {
  position: absolute;
  top: 100%;
  /* Left-aligned to the node's edge (memo dev/45): the row grows rightward,
     so badge positions never shift with the number of attached agents
     (the previous 50%/-50% center anchor re-centered the row per count). */
  left: 0;
  transform: translateY(6px);
  z-index: 5;
  display: flex;
  gap: 6px;
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/attach/NodeAgentBadges.module.css"],"names":[],"mappings":"AAAA;;;sDAGsD;AACtD;EACE,kBAAkB;EAClB,SAAS;EACT;;2EAEyE;EACzE,OAAO;EACP,0BAA0B;EAC1B,UAAU;EACV,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB","sourcesContent":["/* Container that anchors the agent avatars just below their target node. The\n   UniversalNode wrapper is display:contents, so this absolute box anchors to\n   the .react-flow__node element and rides along with pan/zoom/drag. The avatar\n   chips themselves are the shared AgentAvatarBadge. */\n.badges {\n  position: absolute;\n  top: 100%;\n  /* Left-aligned to the node's edge (memo dev/45): the row grows rightward,\n     so badge positions never shift with the number of attached agents\n     (the previous 50%/-50% center anchor re-centered the row per count). */\n  left: 0;\n  transform: translateY(6px);\n  z-index: 5;\n  display: flex;\n  gap: 6px;\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badges": `fNLP7EvNWNeXaHy9b620`
};
export default ___CSS_LOADER_EXPORT___;
